module.exports = __webpack_public_path__ + "cancer-b1d4dfd2382a3770cacb.png";